import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getSetLyricsSheetVersionLink } from 'app/store/SongList/selectors';
import {
  fetchSongEffect,
  setLyricsSheetVersionEffect,
} from 'app/store/SongList/effects';
import { LyricsV2 } from 'app/components/Song/Lyrics/LyricsV2';
import { LyricsVersion } from 'types/lyrics.types';
import { setCoWriterBarSettings } from 'app/store/Settings/slice';

export const Lyrics = () => {
  const { guid } = useParams();
  const dispatch = useAppDispatch();
  const setLyricsVersionLink = useAppSelector(getSetLyricsSheetVersionLink);

  const setLyricsVersion = async (version: LyricsVersion) => {
    try {
      await dispatch(setLyricsSheetVersionEffect({ version })).unwrap();
    } catch (e) {
      await dispatch(fetchSongEffect({ guid: guid as string }));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setCoWriterBarSettings());
    };
  }, [dispatch]);

  useEffect(() => {
    if (setLyricsVersionLink) {
      setLyricsVersion(2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setLyricsVersionLink]);

  return <LyricsV2 />;
};
